import { z } from 'zod'

export default z.object({
  __typename: z.literal('Asset').default('Asset'),
  id: z.string(),
})
